import React, { useEffect, useRef, useState } from 'react';
import { Html5Qrcode } from 'html5-qrcode';

export default function BarcodeScannerHtml5Qrcode({ onDetected }) {
  const regionIdRef = useRef('html5qr_' + Math.random().toString(36).slice(2, 9));
  const scannerRef = useRef(null);
  const [status, setStatus] = useState('init'); // init | starting | ready | error
  const [errMsg, setErrMsg] = useState('');
  const detectedRef = useRef(false); // Flag to prevent duplicate detections
  const onDetectedRef = useRef(onDetected); // Store callback in ref to avoid stale closures

  // Update the callback ref when it changes
  useEffect(() => {
    onDetectedRef.current = onDetected;
  }, [onDetected]);

  useEffect(() => {
    let mounted = true;
    // Reset detection flag when component mounts
    detectedRef.current = false;

    const startScanner = async () => {
      setStatus('starting');
      try {
        const html5Qr = new Html5Qrcode(regionIdRef.current);
        scannerRef.current = html5Qr;
        const config = {
          fps: 10,
          qrbox: { width: 300, height: 180 },
          experimentalFeatures: { useBarCodeDetectorIfSupported: false },
          // verbose: false
        };
        // Start scanning using rear camera where possible
        await html5Qr.start(
          { facingMode: "environment" },
          config,
          (decodedText) => {
            try {
              if (!mounted) return;
              // Prevent duplicate detections
              if (detectedRef.current) {
                console.debug('[Scanner] Ignoring duplicate detection');
                return;
              }

              detectedRef.current = true;
              setStatus('ready');

              // Use the ref to get the latest callback
              const callback = onDetectedRef.current;
              if (callback) {
                callback(String(decodedText));
              }

              // stop scanning after first detection
              try {
                html5Qr.stop()
                  .then(() => html5Qr.clear())
                  .catch(() => { });
              } catch (_) { }
            } catch (e) {
              console.error('[Scanner] Handler error:', e);
            }
          },
          () => {
            // failure per frame; ignore
            // console.debug('html5-qrcode scan error', errorMessage);
          }
        );
        if (mounted) setStatus('ready');
      } catch (e) {
        console.error('html5-qrcode start error', e);
        if (mounted) {
          setErrMsg(e?.message || String(e));
          setStatus('error');
        }
      }
    };

    startScanner();

    return () => {
      mounted = false;
      detectedRef.current = false; // Reset flag on unmount
      try {
        if (scannerRef.current) {
          scannerRef.current.stop().catch(() => { });
          scannerRef.current.clear().catch(() => { });
          scannerRef.current = null; // Clear the ref
        }
      } catch (e) { /* ignore */ }
    };
  }, []); // Remove onDetected from dependencies to prevent stale closures

  return (
    <div style={{ width: '100%' }}>
      {status === 'starting' && <div style={{ padding: 12 }}>Iniciando cámara…</div>}
      {status === 'error' && <div style={{ padding: 12, color: '#b00020' }}>Error al iniciar la cámara: {errMsg}</div>}
      <div id={regionIdRef.current} style={{ width: '100%', height: '40vh', background: '#000' }} />
    </div>
  );
}
